<template>
    <div class="icon-consent">
        <img
            :src="iconUrl"
            alt=""
        >
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            iconUrlMap: {
                email: '/uploads/images/icons/consent-email.png',
                leaflet: '/uploads/images/icons/consent-leaflet.svg',
                phone: '/uploads/images/icons/consent-phone.png',
                sms: '/uploads/images/icons/consent-sms.png'
            }
        }
    },

    computed: {
        iconUrl() {
            if (!this.iconUrlMap.hasOwnProperty(this.type)) {
                console.error(`[IconConsent] No icon url defined for type ${this.type}.`)

                return ''
            }

            return this.iconUrlMap[this.type]
        }
    }
}
</script>

<style lang="scss">
.icon-consent {
    & + & {
        margin-left: 10px;
    }
}
</style>
